import styled from 'styled-components';

export const Value = styled.div`
  width: 100%;
  input,
  select {
    width: 100%;
    outline: none;
    border: none;
    color: var(--grey700);
    font-feature-settings: 'clig' off, 'liga' off;
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px; /* 114.286% */
  }
  & {
    color: var(--grey700);
    font-feature-settings: 'clig' off, 'liga' off;
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px; /* 114.286% */
  }
`;
